import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Auto escalation settings (profilele).
 *
 * Perechile vechi: `settings/easeedesk/auto_escalation_settings`,
 * `get_auto_escalation_list`, `create_auto_escalation_profile`,
 * `change_auto_escalation_profile_status`, `delete_auto_escalation_profile`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface AutoEscalationProfile {
  ID: number
  profile_name: string
  group_id: number
  group_name: string
  escalation_time: number
  active: number
}

export interface AutoEscalationShell {
  title: string
  moduleUrl: string
  departments: { ID: number; name: string }[]
  times: number[]
}

export function autoEscalationShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'auto_escalation_settings'],
    queryFn: () => apiGet<AutoEscalationShell>('/settings/easeedesk/auto_escalation_settings'),
  })
}

export function autoEscalationListQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'auto_escalation_settings', 'list'],
    queryFn: () =>
      apiGet<{ profiles: AutoEscalationProfile[] }>('/settings/easeedesk/auto_escalation_settings/list'),
  })
}

export function createAutoEscalationProfile(name: string, department: number, time: number) {
  return apiPost<{ ok?: boolean; ID?: number }>('/settings/easeedesk/auto_escalation_settings', {
    name,
    department,
    time,
  })
}

export function changeAutoEscalationProfileStatus(profile: number, on: boolean) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/auto_escalation_settings/${profile}/status`, {
    profile_status: on ? 'on' : 'off',
  })
}

export function deleteAutoEscalationProfile(profile: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/auto_escalation_settings/${profile}/remove`, {})
}
